exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".flatpickr-input[data-v-9da1c6bc]{margin-top:.75rem}.btn--primary[data-v-9da1c6bc]{margin-top:1.8rem}h4[data-v-9da1c6bc]{margin-bottom:0;margin-top:2rem;margin-left:.25rem;font-size:1.4rem}.data-table--header[data-v-9da1c6bc]{top:0!important;z-index:1;position:static}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-9da1c6bc","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/accounting/accounts-receivable/reports/ArResidentLedgerReport.vue
// module id = Jok3
// module chunks = 0 1